/**
 * `GET /admin/dashboard` - FR-8.2's four numbers (spec 12's own endpoint).
 *
 * One call, because the three counts and the vendors widget are one screen. Each
 * number is the `total` of the screen it links to, computed server-side from that
 * screen's own predicate, so a tile can never disagree with its detail page.
 */

import { request } from "./client";
import type { WithNotice } from "./types";
import type { Leaderboard } from "./referrals";

export type Dashboard = {
  pending_users: number;
  pending_family_biz: number;
  active_members: number;
  /** FR-8.2's "top third-party vendors by contact volume" - spec 11's leaderboard. */
  top_vendors: Leaderboard;
  /** The window the widget counted over, so the panel states it rather than implying it. */
  top_vendors_days: number;
} & WithNotice;

export function fetchDashboard(topVendorsDays?: number): Promise<Dashboard> {
  return request<Dashboard>("/admin/dashboard", {
    query: { top_vendors_days: topVendorsDays },
  });
}
